import { UserLink, CopyablePhone } from 'components';
import { Page } from 'components/page/page';
import './voucher-perfectmoney.scss';
import { Card } from 'components/card/card';
import { useEffect, useState } from 'react';
import { CreateVoucherResponse, VoucherLog } from 'core/domain/track-voucher/track-voucher';
import { activateVoucher, createVoucher, getVoucherLogs } from 'core/repositories/track-voucher';
import { Input } from 'components/input/input';
import { Button, buttonType } from 'components/button/button';
import { Segmented } from 'antd';
import { SegmentedLabeledOption } from 'antd/es/segmented';
import { faNumToEnNum, IsNumeric } from '../../../../core/utils/decimalExtentions';
import { SettingGoogleAuthType, VoucherPMGoogleAuth } from './google-auth/google-auth';
import { Table } from 'components/table/table';
import { PaginationList } from 'core/domain';

const stages: SegmentedLabeledOption[] = [
    {
        value: 'create',
        label: 'صدور ووچر پرفکت مانی',
    },
    {
        value: 'activate',
        label: 'فعالسازی ووچر پرفکت مانی',
    },
];

interface FilterValues {
    search: string;
}

const empty_filters: FilterValues = {
    search: '',
};

export const VoucherPerfectmoney = () => {
    const [stage, setStage] = useState<SegmentedLabeledOption>(stages[0]);
    const [voucherCode, setVoucherCode] = useState<string>('');
    const [voucherAmount, setVoucherAmount] = useState<string>();
    const [voucherActivationCode, setVoucherActivationCode] = useState<string>('');
    const [voucherInfo, setVoucherInfo] = useState<CreateVoucherResponse>();
    const [loading, setLoading] = useState<boolean>(false);
    const [googleAuthIsLoading, setGoogleAuthIsLoading] = useState<boolean>(false);
    const [isGoogleAuthOpen, setIsGoogleAuthOpen] = useState<boolean>(false);
    const [googleAuth, setGoogleAuth] = useState<SettingGoogleAuthType>();

    const [voucherLogs, setVoucherLogs] = useState<PaginationList<VoucherLog>>();
    const [applyButtonLoading, setApplyButtonLoading] = useState<boolean>(false);
    const [clearButtonLoading, setClearButtonLoading] = useState<boolean>(false);
    const [pageSize, setPageSize] = useState<number>(10);
    const [filterValues, setFilterValues] = useState<FilterValues>(empty_filters);
    const [query, setQuery] = useState('');

    const handleActivateVoucher = async () => {
        if (loading || voucherCode === '') return;

        await activateVoucher(setLoading, setVoucherInfo, {
            voucherCode,
            voucherActivationCode,
        });
    };
    const handleCreateVoucher = async () => {
        setGoogleAuth(undefined);
        setIsGoogleAuthOpen(true);
    };

    const handleNumChange = (value: string) => {
        if (value !== '') value = faNumToEnNum(value);
        // validation nationalCode
        if (value !== '' && !IsNumeric(faNumToEnNum(value[value.length - 1]))) return;

        setVoucherAmount(value);
    };

    const columns: any[] = [
        {
            name: 'نام و نام خانوادگی',
            id: 'fullName',
            selector: (row: VoucherLog) => row.firstName + ' ' + row.lastName,
            cell: (row: VoucherLog) => <UserLink userId={row.userId}>{`${row.firstName ?? ''} ${row.lastName ?? ''}`.trim() || '-'}</UserLink>,
            width: '16%',
        },
        {
            name: 'شماره موبایل',
            id: 'phoneNumber',
            selector: (row: VoucherLog) => row.phoneNumber,
            cell: (row: VoucherLog) => (
                <CopyablePhone phoneNumber={row.phoneNumber} />
            ),
            width: '16%',
        },
        {
            name: 'ووچر',
            id: 'voucher',
            selector: (row: VoucherLog) => row.voucher,
            width: '16%',
        },
        {
            name: 'فعالساز ووچر',
            id: 'activationVoucher',
            selector: (row: VoucherLog) => row.activationVoucher,
            width: '16%',
        },
        {
            name: 'بچ نامبر',
            id: 'batch',
            selector: (row: VoucherLog) => row.batch,
            width: '16%',
        },
        {
            name: 'مقدار',
            id: 'amount',
            selector: (row: VoucherLog) => row.amount,
            width: '16%',
        },
    ];

    const voucherLogsFilterHandle = (clearFilter?: boolean) => {
        var _query = '';

        if (filterValues.search !== '') _query += `${_query.includes('?') ? '&' : '?'}Keyword=${filterValues.search}`;
        setQuery(_query);

        getVoucherLogs(
            clearFilter ? setClearButtonLoading : _query !== '' ? setClearButtonLoading : setLoading,
            setVoucherLogs,
            1,
            pageSize,
            clearFilter ? '' : _query,
        );
    };

    const clearFiltersHandle = () => {
        setFilterValues({ ...filterValues, search: '' });
        voucherLogsFilterHandle(true);
    };

    useEffect(() => {
        voucherLogsFilterHandle();
    }, []);

    return (
        <Page className="pmx-voucher-perfectmoney" title="ووچر پرفکت مانی">
            <Segmented onChange={(e) => setStage(stages.filter((s) => s.value === e)[0])} selected options={stages} />
            <Card className="voucher-tracking" title="استعلام ووچر پرفکت مانی">
                {stage == stages[1] ? (
                    <>
                        <Input
                            value={voucherCode}
                            placeholder="کد ووچر"
                            onChange={(e: any) => setVoucherCode(e.target.value)}
                            maxLength={12}
                        />
                        <Input
                            value={voucherActivationCode}
                            placeholder="کد فعالسازی ووچر"
                            onChange={(e: any) => setVoucherActivationCode(e.target.value)}
                            onPressEnter={handleActivateVoucher}
                            maxLength={24}
                        />
                        <Button
                            loading={loading}
                            disabled={loading || voucherCode === ''}
                            text="فعالسازی"
                            type={buttonType.success}
                            onClick={handleActivateVoucher}
                        />
                    </>
                ) : (
                    <>
                        <Input
                            value={voucherAmount}
                            placeholder="مقدار"
                            onChange={(e: any) => handleNumChange(e.target.value)}
                            onPressEnter={handleCreateVoucher}
                            maxLength={20}
                        />
                        <Button
                            loading={loading}
                            disabled={loading}
                            text="ایجاد ووچر پرفکت مانی جدید"
                            type={buttonType.success}
                            onClick={handleCreateVoucher}
                        />
                    </>
                )}
            </Card>
            <VoucherPMGoogleAuth
                submitData={() => {
                    setIsGoogleAuthOpen(false);
                    createVoucher(setGoogleAuthIsLoading, setVoucherInfo, {
                        amount: voucherAmount,
                        googleAuthCode: googleAuth.code,
                    });
                }}
                data={googleAuth}
                isOpen={isGoogleAuthOpen}
                setIsOpen={setIsGoogleAuthOpen}
                setData={setGoogleAuth}
                loading={googleAuthIsLoading}
            />
            {voucherInfo ? (
                <Card title="اطلاعات ووچر" className="voucher-info">
                    <section>
                        <div className="row">
                            <p>بچ:</p>
                            <span className="en">{voucherInfo?.batchNumber || '-'}</span>
                        </div>
                        {/*<div className="row">*/}
                        {/*  <p>تاریخ فعالسازی:</p>*/}
                        {/*  <span className="en">*/}
                        {/*    {moment(voucherInfo?.activatedDateTime).isValid()*/}
                        {/*      ? moment*/}
                        {/*          .utc(voucherInfo.activatedDateTime)*/}
                        {/*          .locale("fa")*/}
                        {/*          .local()*/}
                        {/*          .format("HH:mm:ss - jYYYY/jMM/jDD")*/}
                        {/*      : "-"}*/}
                        {/*  </span>*/}
                        {/*</div>*/}
                        <div className="row">
                            <p>مقدار:</p>
                            <span className="en">{voucherInfo?.amount || '-'}</span>
                        </div>
                        <div className="row">
                            <p>کد ووچر:</p>
                            <span className="en">{voucherInfo?.voucherCode || '-'}</span>
                        </div>
                        <div className="row">
                            <p>کد فعالسازی ووچر:</p>
                            <span className="en">{voucherInfo?.activationVoucherCode || '-'}</span>
                        </div>
                    </section>
                </Card>
            ) : null}

            <Card title="نمایش گزارشات ووچر" blur={loading} className={'voucher-logs'}>
                <div className="filter-row">
                    <div className="fields">
                        <Input
                            value={filterValues.search}
                            className="search"
                            placeholder="عبارت جهت جستجو را وارد کنید"
                            name="search"
                            onPressEnter={voucherLogsFilterHandle}
                            onChange={(e) =>
                                setFilterValues({
                                    ...filterValues,
                                    search: e.target.value,
                                })
                            }
                        />
                    </div>
                    <div className="buttons">
                        <Button
                            loading={applyButtonLoading}
                            disabled={applyButtonLoading}
                            text="اعمال فیلتر"
                            type={buttonType.success}
                            onClick={() => voucherLogsFilterHandle()}
                        />
                        <Button
                            loading={clearButtonLoading}
                            disabled={clearButtonLoading}
                            text="حذف فیلتر"
                            type={buttonType.error}
                            onClick={clearFiltersHandle}
                        />
                    </div>
                </div>

                <Table
                    setPageSize={setPageSize}
                    blur={loading}
                    setloader={setLoading}
                    getdata={getVoucherLogs}
                    setdata={setVoucherLogs}
                    className="saved-wallets-table"
                    data={voucherLogs?.items}
                    pagination={voucherLogs?.pagination}
                    column={columns}
                    filters={query}
                />
            </Card>
        </Page>
    );
};
